// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"96571fc1","293":"4af110b7","308":"5e57ac18","422":"8758cba2","493":"143461de","722":"53f2818d"}[chunkId] + ".chunk.js";
};